import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import SortButton from '../SortButton/SortButton';

const Header = styled.div`
    display: flex;
    margin: 20px 14px;

    ${SortButton} {
        margin-right: 10px;
    }

    ${media.mdmin`
        margin: 20px 16px;
    `}

    ${media.lgmin`
        margin: 20px 32px 20px 32px;
    `}
`;

const HeadingWrapper = styled.div`
    flex: 1;
    margin-right: 10px;

    ${media.mdmin`
        flex: 0;
    `}
`;

const Body = styled.div`
    margin: 25px 0 0 14px;

    ${media.lgmin`
        margin-left: 32px;
    `}
`;

const Footer = styled.div`
    margin-top: 13px;
    padding-bottom: 40px;
    text-align: center;
    width: 100%;

    ${media.mdmin`
        padding-bottom: 50px;
    `}

    ${media.lgmin`
        padding-bottom: 60px;
    `}
`;

const SectionTemplate = ({
    heading,
    tags,
    body,
    footer,
    notification,
    sort,
    modals,
}) => {

    return (
        <>
            {notification}
            <Header>
                <HeadingWrapper>
                    {heading}
                </HeadingWrapper>
                {sort}
            </Header>
            {tags}
            <Body>
                {body}
            </Body>
            <Footer>
                {footer}
            </Footer>
            {modals}
        </>
    );

};

SectionTemplate.propTypes = {
    body: PropTypes.element,
    heading: PropTypes.element,
    tags: PropTypes.element,
    footer: PropTypes.element,
    notification: PropTypes.element,
    sort: PropTypes.element,
    modals: PropTypes.element,
};

SectionTemplate.defaultProps = {
    body: undefined,
    heading: undefined,
    tags: undefined,
    footer: undefined,
    notification: undefined,
    sort: undefined,
    modals: undefined,
};

export default SectionTemplate;
